import React from "react";
import {
  Shield,
  User,
  CreditCard,
  Database,
  Globe,
  Mail,
  Key,
  Info,
  X,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import SEOHead from "../CommanComponents/SEOHead";
function AydinlatmaMetni() {
  // Geri gitme fonksiyonu
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1);
  };
  return (
    <div className="max-w-6xl mx-auto p-2 md:p-6 bg-gray-50 rounded-2xl ">
      <SEOHead
        title="KVKK Aydınlatma Metni"
        description="Classroom kişisel verilerin korunması ve işlenmesi hakkında aydınlatma metni."
      />
      <div className="flex justify-end mb-4">
        {/* justify-start ile sola hizalayın */}
        <button
          onClick={handleGoBack}
          className="p-3 rounded-full bg-red-500 text-white hover:bg-red-700 transition-all duration-200 shadow-lg hover:shadow-xl"
          aria-label="Geri dön"
        >
          <X className="w-6 h-6" />
        </button>
      </div>
      {/* Hero Başlık */}
      <div className="text-center mb-12">
        <div className="inline-flex items-center justify-center gap-3 mb-6">
          <div className="bg-purple-600 p-3 rounded-full shadow-lg">
            <Shield className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl md:text-3xl font-extrabold text-gray-900">
            KVKK Aydınlatma Metni
          </h1>
        </div>
        <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
          6698 sayılı Kişisel Verilerin Korunması Kanunu ("Kanun") uyarınca,
          kişisel verilerinizin işlenme süreçleri hakkında bilgilendirme
          amacıyla hazırlanmıştır.
          <br />
          <span className="text-sm font-medium text-purple-600 mt-2 block">
            Son güncelleme: 15 Ocak 2026
          </span>
        </p>
      </div>

      <div className="space-y-8">
        {/* Veri Sorumlusu Bilgisi */}
        <div className="bg-purple-600 rounded-3xl p-8 shadow-xl transform transition hover:scale-[1.01]">
          <div className="flex items-center gap-3 mb-4 text-white">
            <Info className="w-6 h-6" />
            <h2 className="text-2xl font-bold">Veri Sorumlusu</h2>
          </div>
          <p className="text-purple-50 leading-relaxed text-lg">
            Bu Aydınlatma Metni kapsamında kişisel verileriniz;{" "}
            <strong>veri sorumlusu</strong> sıfatıyla
            <span className="underline decoration-yellow-400 mx-1 text-white font-semibold">
              Ali ZİLAN
            </span>
            ( Classroom) tarafından Kanun’a uygun olarak işlenmektedir.
          </p>
        </div>

        {/* İşlenen Kişisel Veriler */}
        <div className="bg-white rounded-3xl shadow-md px-2 py-6 border border-gray-100">
          <div className="flex items-center gap-4 mb-8 border-b pb-4">
            <div className="bg-purple-100 p-3 rounded-2xl">
              <Database className="w-6 h-6 text-purple-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900">
              İşlenen Kişisel Veriler
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <div className="flex items-start gap-4 p-5 bg-gray-50 rounded-2xl border border-gray-100 transition-colors hover:bg-white hover:shadow-sm">
                <User className="w-6 h-6 text-purple-500 mt-1 flex-shrink-0" />
                <div>
                  <h4 className="font-bold text-gray-900 mb-1 italic">
                    Kimlik Bilgileri
                  </h4>
                  <p className="text-sm text-gray-600">
                    Ad, soyad, kullanıcı adı ve profil bilgileri.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-5 bg-gray-50 rounded-2xl border border-gray-100 transition-colors hover:bg-white hover:shadow-sm">
                <Mail className="w-6 h-6 text-purple-500 mt-1 flex-shrink-0" />
                <div>
                  <h4 className="font-bold text-gray-900 mb-1 italic">
                    İletişim Bilgileri
                  </h4>
                  <p className="text-sm text-gray-600">
                    E-posta adresi ve sistem bildirim tercihleri.
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-4">
              <div className="flex items-start gap-4 p-5 bg-gray-50 rounded-2xl border border-gray-100 transition-colors hover:bg-white hover:shadow-sm">
                <Globe className="w-6 h-6 text-purple-500 mt-1 flex-shrink-0" />
                <div>
                  <h4 className="font-bold text-gray-900 mb-1 italic">
                    Teknik Bilgiler
                  </h4>
                  <p className="text-sm text-gray-600">
                    IP adresi, tarayıcı türü, uygulama içi hareketler ve cihaz
                    verileri.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-5 bg-gray-50 rounded-2xl border border-gray-100 transition-colors hover:bg-white hover:shadow-sm">
                <CreditCard className="w-6 h-6 text-purple-500 mt-1 flex-shrink-0" />
                <div>
                  <h4 className="font-bold text-gray-900 mb-1 italic">
                    Ödeme İşlem Verileri
                  </h4>
                  <p className="text-sm text-gray-600">
                    Ödeme onayı ve referans numarası.{" "}
                    <span className="text-purple-600 font-medium">
                      Kredi kartı bilgileriniz doğrudan iyzico altyapısında
                      işlenir; platformumuzda tutulmaz.
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Veri Aktarımı */}
        <div className="bg-white rounded-3xl shadow-md p-8 border border-gray-100">
          <h2 className="text-2xl font-bold text-gray-900 mb-8 flex items-center gap-3">
            <Globe className="w-7 h-7 text-purple-600" /> Veri Aktarımı
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-center gap-5 p-6 bg-white rounded-2xl border-2 border-purple-50 shadow-sm">
              <div className="bg-purple-600 p-4 rounded-xl shadow-md">
                <CreditCard className="w-7 h-7 text-white" />
              </div>
              <div>
                <h4 className="font-black text-gray-900 text-lg uppercase">
                  iyzico
                </h4>
                <p className="text-sm text-gray-600">
                  Ödeme Tahsilatı ve Güvenlik Kontrolü
                </p>
              </div>
            </div>

            <div className="flex items-center gap-5 p-6 bg-white rounded-2xl border-2 border-purple-50 shadow-sm">
              <div className="bg-purple-600 p-4 rounded-xl shadow-md">
                <Database className="w-7 h-7 text-white" />
              </div>
              <div>
                <h4 className="font-black text-gray-900 text-lg uppercase">
                  Render
                </h4>
                <p className="text-sm text-gray-600">
                  Bulut Veri Saklama ve Altyapı Hizmeti
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Haklarınız ve Başvuru */}
        <div className="bg-white rounded-3xl px-2 py-8 shadow-md border border-gray-100">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">
            Haklarınız ve İletişim
          </h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            Kanun'un 11. maddesi uyarınca; verilerinizin silinmesini talep etme,
            işlenip işlenmediğini öğrenme ve düzeltme yapılmasını isteme
            haklarına sahipsiniz.
          </p>

          <div className="bg-gray-50 rounded-2xl px-1 py-6 border-l-4 border-purple-600">
            <p className="text-gray-800 font-medium mb-3">Başvuru Kanalları:</p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="mailto:classroomdestek@gmail.com"
                className="flex items-center text-purple-700 font-semibold hover:underline"
              >
                classroom.destek@gmail.com
              </a>
              <span className="hidden sm:inline text-gray-300">|</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AydinlatmaMetni;
